<h2 mat-dialog-title class="dialog-header">
    <span class="dialog-title title-large">{{ dialogTitle }}</span>

    <button
        mat-icon-button
        type="button"
        [attr.aria-label]="'receipts.ui.chiudi' | transloco"
        class="close-button"
        (click)="onClose()"
    >
        <i class="fa-regular fa-xmark"></i>
    </button>
</h2>

<mat-dialog-content class="content" [formGroup]="addContactForm">
    <mat-form-field appearance="outline">
        <mat-label>{{ 'receipts.ui.nomeECognome' | transloco }}</mat-label>
        <input matInput formControlName="nomeCognome">
        <mat-error>{{ 'receipts.ui.nomeECognomeObbligatorio' | transloco }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>{{ 'receipts.ui.telefono' | transloco }}</mat-label>
        <input matInput type="tel" inputmode="numeric" maxlength="20" pattern="[0-9]{0,20}" formControlName="telefono">
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>{{ 'receipts.ui.cellulare' | transloco }}</mat-label>
        <input matInput type="tel" inputmode="numeric" maxlength="20" pattern="[0-9]{0,20}" formControlName="cellulare">
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Fax</mat-label>
        <input matInput type="tel" inputmode="numeric" maxlength="20" pattern="[0-9]{0,20}" formControlName="fax">
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>{{ 'receipts.ui.ruolo' | transloco }}</mat-label>
        <input matInput formControlName="ruolo">
    </mat-form-field>

    <mat-form-field appearance="outline" class="text-area-custom">
        <mat-label>{{ 'receipts.ui.note' | transloco }}</mat-label>
        <textarea matInput formControlName="note" rows="3"></textarea>
    </mat-form-field>

    <mat-slide-toggle formControlName="default" labelPosition="before">
        {{ 'receipts.ui.contattoPrincipale' | transloco }}
    </mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions class="buttons-container">
    <button matButton (click)="onReset()">{{ 'receipts.ui.cancella' | transloco }}</button>
    <button matButton="filled" (click)="onApply()">{{ 'receipts.ui.applica' | transloco }}</button>
</mat-dialog-actions>
